<template>
  <div class="rich-bubble" tabindex="0" :class="{'me': me, 'loading': loading }">
    <div>
      <span v-if="senderName" class="message-sender">{{ senderName + ':' }}</span>
      <span v-if="time" class="message-time">{{ time }}</span>
    </div>
    <div v-html="link" v-if="link"></div>
    <VueMarkdown :source="text" v-else/>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render'

export default {
  name: 'RichBubble',
  components: { VueMarkdown },
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    me: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    link: {
      type: Boolean,
      default: false
    },
    time: {
      type: String
    },
    senderName: {
      type: String
    }
  }
}
</script>

<style lang="sass" scoped>
.rich-bubble
  padding: 10px 12px
  border-radius: 21px
  color: var(--text-element)
  border: 1px solid var(--background-element)
  display: inline-block
  position: relative
  background-color: var(--background)
  min-width: 50px
  border-top-left-radius: 0
  word-wrap: break-word
  flex-grow: 0
  line-height: 1rem
  width: 100%

  :deep(ol)
    padding-left: 24px

    li
      line-height: 1rem

  :deep(p)
    margin: 0 !important
    display: inline-block
    line-height: 1rem
    font-size: 12px

  &::before
    content: var(--bubble-left)
    position: absolute
    left: 0
    top: 0
    margin-top: -10px
    margin-left: -4px
    transform: scale(0.8)

  &.me
    background-color: var(--background-element)
    border: 1px solid var(--background-element)
    color: var(--text-element)
    border-top-left-radius: 21px
    border-top-right-radius: 0

    &::before
      content: ''

    &::after
      content: var(--bubble-right)
      position: absolute
      right: 0
      top: 0
      margin-top: -6px
      margin-right: -1px

  &.loading
    height: 16px
    animation: loading .8s var(--animation-timing) infinite

@keyframes loading
  0%
    opacity: 0
  50%
    opacity: 1
  100%
    opacity: 0

.message-time
  float: right
  font-size: 11px

.message-sender
  font-weight: 600
  font-size: 12px
  color: #565656

</style>
